<template>
    <div v-if="category">
        <div class="row m-b-20">
            <div class="col-6">
                <b-card :title="category.name" :img-src="getImage()" img-alt="Image" img-top bg-variant="dark" text-variant="light">
                    <b-card-text>{{ category.description }} </b-card-text>
                </b-card>
            </div>
            <div class="col-6">
                <b-card class="m-b-20" header-tag="header" header-bg-variant="dark" header-text-variant="light">
                    <template v-slot:header>
                        <h6 class="mb-0">Details</h6>
                    </template>
                    <b-card-text>
                        <p v-if="category.parent">
                            <b>Parent category: </b>
                            <a v-bind:href="categoryLink(category.parent)" class="text-black">
                                {{ category.parent.name }}
                            </a>
                        </p>
                        <p v-if="category.children.length">
                            <b>Child categories: </b>
                            <ul>
                                <li v-for="child in category.children" :key="child.id">
                                    <a v-bind:href="categoryLink(child)" class="text-black">
                                    {{ child.name }}
                                    </a>
                                </li>
                            </ul>
                        </p>
                        <p v-if="category.items.length">
                            <b>Items in category: </b>
                            <ul>
                                <li v-for="item in category.items" :key="item.id">
                                    <a v-bind:href="itemLink(item)" class="text-black">
                                    {{ item.name }}
                                    </a>
                                </li>
                            </ul>
                        </p>
                    </b-card-text>
                </b-card>
                <b-card header-tag="header" header-bg-variant="dark" header-text-variant="light">
                    <template v-slot:header>
                        <h6 class="mb-0">Notes</h6>
                    </template>
                    <b-card-text>
                        <vue-custom-scrollbar class="height-sm">
                            <ul class="media-list media-list-with-divider media-messaging">
                                <li class="media media-sm" v-for="(note, index) in category.notes" :key="note.id">
                                    <div class="media-body">
                                        <h5 class="media-heading">Note #{{ index + 1 }}</h5>
                                        <p>{{ note.content }}</p>
                                    </div>
                                </li>
                                <li v-if="!category.notes.length" class="media media-sm">
                                    <div class="media-body">
                                        <p>No notes</p>
                                    </div>
                                </li>
                            </ul>
                        </vue-custom-scrollbar>
                    </b-card-text>
                </b-card>
            </div>
        </div>
        <b-card class="m-b-20" header-tag="header" header-bg-variant="dark" header-text-variant="light">
            <template v-slot:header>
                <h6 class="mb-0">Files</h6>
            </template>
            <div class="row">
                <div class="m-20 text-center" v-for="file in category.files" :key="file.id">
                    <a :href="fileUrl + file.fileFd" :download="file.name" target="_blank">
                        <i v-if="fileType(file.fileFd) == 'pdf'" class="fas fa-file-pdf fa-5x" />
                        <i v-else-if="fileType(file.fileFd) == ('jpg' || 'jpeg')" class="fas fa-file-image fa-5x" />
                        <p class="text-black">{{ file.name }}</p>
                    </a>
                </div>
            </div>
            <div v-if="!category.files.length">
                <p>No files</p>
            </div>
        </b-card>
        <b-card class="m-b-20" header-tag="header" header-bg-variant="dark" header-text-variant="light">
            <template v-slot:header>
                <h6 class="mb-0">Actions</h6>
            </template>
            <url-button class="btn-secondary" label="Back to list" :url="`/eventbank/${$route.params.type}/categories`" />
        <button v-b-modal.modalAlert class="btn btn-danger pull-right">Delete</button>
        <url-button class="btn-yellow pull-right" label="Edit" :url="`/eventbank/${$route.params.type}/categories/${$route.params.id}/edit`" />
        </b-card>
        
        <b-modal id="modalAlert" :title="'Delete ' + category.name" centered cancel-variant="white" ok-variant="danger" ok-title="Delete" v-on:ok="deleteCategory">
            <div class="alert alert-danger m-b-0">
                <h5><i class="fa fa-info-circle"></i>Delete</h5>
                <p>Are you sure you want to delete {{ category.name }}?</p>
            </div>
        </b-modal>
    </div>
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'

export default {
    name: 'Category',
    props: ['category'],
    components: {
        UrlButton
    },
    methods: {
        getImage() {
            if(this.category.image) {
                return this.imageUrl + this.category.image.imageFd;
            } else {
                return require('../../assets/images/no_image.jpg');
            }
        },
        deleteCategory() {
            if (this.category.image) {
                this.$parent.removeImage(this.category.image.id)
            }
            this.category.files.forEach(file => {
                this.$parent.removeFile(file.id)
            });
            this.$parent.deleteCategoryCall(this.category.id);
        },
        fileType(path) {
           return path.slice(path.lastIndexOf('.') + 1);
        },
        categoryLink(item) {
            let type = item.type
            if (typeof type === 'number') {
                type = this.$store.state.type.types.find(t => t.id === item.type)
            }
            return '/eventbank/' + type.name.toLowerCase() + '/categories/' + item.id
        },
        itemLink(item) {
            let type = item.type
            if (typeof type === 'number') {
                type = this.$store.state.type.types.find(t => t.id === item.type)
            }
            return '/eventbank/' + type.name.toLowerCase() + '/items/' + item.id
        }
    },
    data() {
        return {
            image: null,
            imageElement: null,
            imageUrl: process.env.VUE_APP_API_URL + '/uploads/images/',
            fileUrl: process.env.VUE_APP_API_URL + '/uploads/files/'
        }
    },
    created() {
        this.$store.dispatch('type/getTypes')
        this.$parent.getCategoryCall()
    }
}
</script>